import { defineStore } from 'pinia'

interface State {
    storeName: string
}

export const useGlobalStore = defineStore('global', {
    state: (): State => ({
        storeName: '',
    }),

    actions: {
        setStoreName(newStoreName: State['storeName']) {
            this.storeName = newStoreName
        },
    },
})
